import { ReactComponent as GreenIcon } from "../assets/icons/tick-circle-green.svg";
import { ReactComponent as GeayIcon } from "../assets/icons/tick-circle-gray.svg";

interface Probs {
  message: string;
  isValid: boolean;
}

const ValidationList: React.FC<Probs> = ({ isValid, message }) => {
  return (
    <div>
      {isValid ? (
        <GreenIcon style={{ height: "20px", width: "20px" }} />
      ) : (
        <GeayIcon style={{ height: "20px", width: "20px" }} />
      )}
      <span style={{ fontSize: 14, lineHeight: "18px" ,paddingLeft: 4 , color: isValid ?'#171D27': '#A4B1C0' }}>{message}</span>
    </div>
  );
};

export default ValidationList;
